import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMute: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="mute, sound-off"><path fillRule="evenodd" clipRule="evenodd" d="M3.74816 21.3108L21.3088 3.75011L20.2482 2.68945L17 5.93761V2.9707L9.8043 7.0003H5V17.0003H5.93732L2.6875 20.2501L3.74816 21.3108ZM7.43732 15.5003H6.5V8.5003H10.1957L15.5 5.52989V7.43761L7.43732 15.5003Z" fill="currentColor"/><path d="M15.5 18.4707L11.1474 16.0332L10.0454 17.1353L17 21.0299V10.1806L15.5 11.6806V18.4707Z" fill="currentColor"/></CentralIconBase>;
};

export default IconMute;
